import Vue from "vue";

import TicketEntryWrapper from "./TicketEntryWrapper.vue";

export function load() {
    const selector = "ticket-entry";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(TicketEntryWrapper, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
